export default {
    methods: {
        copyToClipboard(content, options = {}) {
            if (this.$clipboard(content)) {
                this.notifySuccess("Скопировано в буфер обмена", options);
            } else {
                this.notifyError("Буфер обмена недоступен", options);
                alert(content);
            }
        },
    },
}
